import React from "react";
import Tariffs from "@page-contents/tariffs";
import Layout from "@components/layout";

export default props => (
	<Layout {...props} meta={{ title: "Тарифы" }}>
		<Tariffs />
	</Layout>
);
